/**
 * Which enquiry id the sidebar's flow links (`/rfq`, `/suppliers`, `/compare`, `/quote`,
 * `/revisions`) carry — pinned as pure functions per this repo's no-component-test-infra
 * convention (see `lib/uom.test.ts`'s own header for the pattern).
 *
 * There is no default enquiry. The old `DEMO_ENQUIRY_ID` (`REQ-1042`, mock seed data that
 * never existed on the live bench) is gone; a session that hasn't opened a real enquiry yet
 * has nothing to fall back to, and must say so rather than invent an id.
 */

/**
 * The id currently backing the flow screens: the route's own `:id` param if the URL has one,
 * else the last enquiry actually opened this session, else `null` when neither exists.
 *
 * `lastOpenedId` must only ever be set from an id that was actually navigated to (see
 * `ActiveEnquiryProvider`) — never invented here.
 */
export function resolveActiveEnquiryId(
  paramsId: string | undefined,
  lastOpenedId: string | null,
): string | null {
  return paramsId ?? lastOpenedId ?? null
}

/**
 * Where a flow nav link (or a bare flow path like `/rfq` with no `:id`) should go: the
 * per-enquiry page when an id is known, else the Requirements board so the user picks one —
 * never a fabricated document id.
 */
export function flowLinkTarget(base: string, activeId: string | null): string {
  return activeId ? `${base}/${activeId}` : '/requirements'
}
